/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react';
import { Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Refresh } from './style';

const reload = () => {
  window.location.reload();
};

const NoMatch = () => {

  useEffect(() => {
    document.title = "DFS | Page Not Found";
  });

  return (
    <Container xs="12" className="my-5">
      <h1>
        404
        <br />
        <small>Page not found.</small>
      </h1>
      <h3>Sorry, this page failed to load or no longer exists.</h3>
      You can try
      <Refresh className="skip-nav-focus" onClick={reload}> <u>reload this page</u> </Refresh>
      or
      <Link to="/"> <u>return to the home</u></Link>.
    </Container>
  );
};

export default NoMatch;